import { forwardRef, ReactNode } from 'react';

import { mergeSx, Stack, tokens } from '@cast/design-system';

import { useMainLayout } from 'main-layout-op/_providers/MainLayoutProvider';

import { Product } from '@cast/console-types';

import { ApaSidebar } from './features/ApaSidebar';
import { AuditLogSidebar } from './features/AuditLogSidebar';
import { AutomationSidebar } from './features/AutomationSidebar';
import { DboSidebar } from './features/dbo/DboSidebar';
import { SecuritySidebar } from './features/SecuritySidebar';
import { SettingsSidebar } from './features/SettingsSidebar';
import { SECONDARY_SIDEBAR_WIDTH } from '../../../_constants';
import type { StackProps } from '@cast/design-system';

type SidebarProps = StackProps;

const PRODUCT_TO_SIDEBAR: Record<Product, ReactNode> = {
  reporting: <AutomationSidebar />,
  automation: <AutomationSidebar />,
  dbo: <DboSidebar />,
  settings: <SettingsSidebar />,
  security: <SecuritySidebar />,
  apa: <ApaSidebar />,
  llm: null,
  auditLog: <AuditLogSidebar />,
};

export const SecondarySidebar = forwardRef<HTMLDivElement, SidebarProps>(
  ({ ...boxProps }: SidebarProps, ref) => {
    const { selectedSidebarProduct } = useMainLayout();

    return (
      <Stack
        id="main-sidebar"
        bgcolor={tokens.theme.bg.structural.page}
        data-testid="secondary-sidebar"
        {...boxProps}
        sx={mergeSx(
          {
            width: SECONDARY_SIDEBAR_WIDTH,
            height: '100%',
            flexShrink: 0,
            overflow: 'hidden',
            borderRight: '1px solid',
            borderColor: tokens.theme.border.structural.neutral,
          },
          boxProps.sx
        )}
        ref={ref}
      >
        <Stack pt={16} height="100%" overflow="hidden">
          {PRODUCT_TO_SIDEBAR[selectedSidebarProduct]}
        </Stack>
      </Stack>
    );
  }
);

SecondarySidebar.displayName = 'Sidebar';
